import {
  Box,
  Button,
  Collapse,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import expandIcon from "../../../../assets/icons/expandDown.svg";
import shrinkIcon from "../../../../assets/icons/expandUp.svg";
import crownIcon from "../../../../assets/icons/CrownSimple.svg";
import { useSelector } from "react-redux";
import { formatIndianNumber } from "../common-functions/PaymentCommonFunctions";
import { useDispatch } from "react-redux";
import {
  setActiveStep,
  setEditPreviewApplicant,
  enableEditForm,
  setisUpgradePreferentialStep
} from "../../voucher-form.slice";
import { useHistory, useParams } from "react-router-dom";
import { route } from "../../../../services/apiRoutes";
const PreferentialAccordion = () => {
  const [open, setOpen] = useState(true);
  const history = useHistory();
  const { applicantData,eoiCampaignDetails } = useSelector((state) => state.voucherForm);
  const dispatch = useDispatch();
  const { voucherId } = useParams();
  function extractPaymentDetails(data, eoiCampaignDetails) {
    // Determine payable amount based on EOI type
    const amountPayable =
      eoiCampaignDetails?.eoiType?.includes('Preferential')
        ? Number(eoiCampaignDetails?.preEoiAmount) || 0
        : Number(eoiCampaignDetails?.stdEoiAmount) || 0;

    // Paid: prefer totalAmountPaid, else sum of transactions, else 0
    let amountPaid = Number(data?.totalAmountPaid) || 0;

    if (!amountPaid && Array.isArray(data?.transactions)) {
      amountPaid = data?.transactions?.reduce((sum, txn) => {
        const paid = Number(txn?.paidAmount) || 0;
        return sum + paid;
      }, 0);
    }

    // Balance Due = Payable - Paid
    let amountDue = amountPayable - amountPaid;
    if (amountDue < 0) amountDue = 0;

    return {
      amountPayable,
      amountPaid,
      amountDue,
    };
  }




  const PaymentObject = extractPaymentDetails(applicantData?.paymentDetails);
  const unitPreferenceStep = applicantData?.noOfApplicants + 1;

  const handleUpgrade = async () => {
    const payload = {
      lastStep: 1,
    };
    const res = await dispatch(
      enableEditForm({
        path: `${route.ENABLE_EDIT}/${voucherId}`,
        payload,
        opportunityId: voucherId,
      })
    ).unwrap();

    // ✅ Navigate only on success response
    if (res?.status === 200 || res?.status === 201) {
      history.push(`/voucher-form/${voucherId}`);
      dispatch(setEditPreviewApplicant(true));
      dispatch(setisUpgradePreferentialStep(true))
      dispatch(setActiveStep(unitPreferenceStep));
    }
  };
  return (
    <Box
      sx={{
        border: "1px solid rgba(26, 64, 125, 0.1)",
        borderRadius: "16px",
        backgroundColor: "rgba(201, 222, 255, 1)",
      }}
      p={2}
      mb={3}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          cursor: "pointer",
        }}
        onClick={() => setOpen(!open)}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography variant="body2" sx={{ fontWeight: 600 }}>
            Want to upgrade to { eoiCampaignDetails?.eoiType?.includes('Preferential') ?'Preferential': 'Standard'} EOI?
          </Typography>
        </Box>
        <img src={open ? shrinkIcon : expandIcon} alt="toggle-icon" />
      </Box>

      <Collapse in={open}>
        <Box>
          <Box
            mt={3}
            sx={{
              backgroundColor: "#fff",
              padding: "1rem",
              borderRadius: "1rem",
            }}
          >
            <Grid container spacing={1} alignItems={"center"}>
              <Grid item xs={6}>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  Total
                </Typography>
              </Grid>
              <Grid item xs={6} textAlign="right">
                <Typography
                  sx={{
                    fontSize: "20px",
                    fontWeight: 700,
                    color: "rgba(26, 64, 125, 1)",
                  }}
                >
                  ₹{formatIndianNumber(eoiCampaignDetails?.eoiType?.includes('Preferential') ? eoiCampaignDetails?.preEoiAmount :eoiCampaignDetails?.stdEoiAmount || 0)}

                </Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  Paid
                </Typography>
              </Grid>
              <Grid item xs={6} textAlign="right">
                <Typography
                  sx={{
                    fontSize: "20px",
                    fontWeight: 700,
                    color: "rgba(26, 64, 125, 1)",
                  }}
                >
                  ₹{formatIndianNumber(PaymentObject?.amountPaid || 0)}

                </Typography>
              </Grid>
            </Grid>

            <Divider sx={{ my: 1.5 }} />

            <Grid container mt={2} alignItems={"center"}>
              <Grid item xs={6}>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  Balance Due
                </Typography>
              </Grid>
              <Grid item xs={6} textAlign="right">
                <Typography
                  sx={{
                    fontSize: "20px",
                    fontWeight: 700,
                    color: "rgba(26, 64, 125, 1)",
                  }}
                >
                 ₹{formatIndianNumber(PaymentObject?.amountDue || 0)}

                </Typography>
              </Grid>
            </Grid>
          </Box>
         {applicantData?.isUpgradableToEOI &&  <Box textAlign="center" mt={3}>
            <Button
              variant="outlined"
              onClick={() => {
                handleUpgrade();
              }}
              // size="large"
              sx={{
                borderRadius: "8px",
                fontWeight: 600,
                borderColor: "rgba(26, 64, 125, 1)",
                color: "#fff",
                textTransform: "none",
                fontSize: "14px",
                px: 2,
                py: 1.5,
                backgroundColor: "rgba(26, 64, 125, 1)",
                "&:hover": {
                  backgroundColor: "rgba(26, 64, 125, 1)",
                },
              }}
            >
              {" "}
              <img
                src={crownIcon}
                alt="crown-icon"
                style={{ marginRight: "0.5rem" }}
              />
              Upgrade to {eoiCampaignDetails?.eoiType?.includes('Preferential') ? 'Preferential' :'Standard'}
            </Button>
          </Box>}
        </Box>
      </Collapse>
    </Box>
  );
};

export default PreferentialAccordion;